import { FunctionalComponent, h } from 'preact';
import { useTheme } from 'styled-components';

const LinkIcon: FunctionalComponent = () => {
  const theme = useTheme();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%">
      <path
        d="M10.333.667h-2c-.366 0-.666.3-.666.666 0 .367.3.667.666.667h2c1.1 0 2 .9 2 2s-.9 2-2 2h-2c-.366 0-.666.3-.666.667 0 .366.3.666.666.666h2a3.335 3.335 0 000-6.666zM4.333 4c0 .367.3.667.667.667h4c.367 0 .667-.3.667-.667 0-.367-.3-.667-.667-.667H5c-.367 0-.667.3-.667.667zm1.334 2h-2c-1.1 0-2-.9-2-2s.9-2 2-2h2c.366 0 .666-.3.666-.667 0-.366-.3-.666-.666-.666h-2a3.335 3.335 0 000 6.666h2c.366 0 .666-.3.666-.666 0-.367-.3-.667-.666-.667z"
        fill={theme.ui.links.iconColor}
        fillRule="nonzero"
      />
    </svg>
  );
};

export default LinkIcon;
